import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function StrikethroughIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "15"}
      height={height || "14"}
      viewBox="0 0 15 14"
    >
      <path
        id="Path_10404"
        data-name="Path 10404"
        d="M6.078-.14A6.459,6.459,0,0,1,3.525-.611,4.128,4.128,0,0,1,1.792-1.924,3.3,3.3,0,0,1,1.12-3.807H2.675A2.7,2.7,0,0,0,3.62-2.052,3.566,3.566,0,0,0,6.078-1.3a3.614,3.614,0,0,0,2.363-.716,2.247,2.247,0,0,0,.872-1.814A2.05,2.05,0,0,0,8.83-5.248a2.96,2.96,0,0,0-1.2-.8A19.554,19.554,0,0,0,5.658-6.63a18.133,18.133,0,0,1-2.332-.725,3.679,3.679,0,0,1-1.471-1.1,3.1,3.1,0,0,1-.609-2.02,3.2,3.2,0,0,1,.588-1.892,3.884,3.884,0,0,1,1.66-1.3,6.059,6.059,0,0,1,2.458-.471,5.368,5.368,0,0,1,3.288.931,3.45,3.45,0,0,1,1.439,2.4h-1.6a2.443,2.443,0,0,0-.987-1.5,3.589,3.589,0,0,0-2.269-.657,3.592,3.592,0,0,0-2.206.657,2.116,2.116,0,0,0-.882,1.794A1.985,1.985,0,0,0,3.221-9.12a3.084,3.084,0,0,0,1.208.8,18.821,18.821,0,0,0,1.964.588A18.617,18.617,0,0,1,8.7-6.993,3.733,3.733,0,0,1,10.2-5.885a3.064,3.064,0,0,1,.609,2,3.354,3.354,0,0,1-.546,1.824A3.894,3.894,0,0,1,8.641-.669,5.732,5.732,0,0,1,6.078-.14Z"
        transform="translate(1.151 14.14)"
        fill={color || "#333"}
      />
      <rect
        id="Rectangle_1924"
        data-name="Rectangle 1924"
        width="15"
        height="0.5"
        transform="translate(0 7.16)"
        fill={color || "#333"}
      />
    </svg>
  );
}
